(ns ui.components.toast.view
  (:require
   [reagent.core :as r]
   ["react-hot-toast" :default Toast :refer (Toaster)]))

(def react-hot-toast-toaster (r/adapt-react-class Toaster))

(defn toaster
  []
  (let []
    [react-hot-toast-toaster
     {:containerStyle {:z-index "100000"}
      :toastOptions   {:style   {:border-radius "4px"}
                       :success {:duration  3000
                                 :iconTheme {:primary "#8ABF4C"}}}}]))
